"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var CustomNodeGroupStorage_1, _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const TCustomNodeGroupFactory_1 = require("../../types/container/custom-nodes/TCustomNodeGroupFactory");
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const CustomNodeGroup_1 = require("../../enums/custom-nodes/CustomNodeGroup");
const MapStorage_1 = require("../MapStorage");
let CustomNodeGroupStorage = CustomNodeGroupStorage_1 = class CustomNodeGroupStorage extends MapStorage_1.MapStorage {
    constructor(customNodeGroupFactory, randomGenerator, options) {
        super(randomGenerator, options);
        this.customNodeGroupFactory = customNodeGroupFactory;
    }
    initialize() {
        super.initialize();
        CustomNodeGroupStorage_1.customNodeGroupsList.forEach((customNodeGroupName) => {
            const customNodeGroup = this.customNodeGroupFactory(customNodeGroupName);
            this.storage.set(customNodeGroupName, customNodeGroup);
        });
    }
};
CustomNodeGroupStorage.customNodeGroupsList = [
    CustomNodeGroup_1.CustomNodeGroup.ConsoleOutputCustomNodeGroup,
    CustomNodeGroup_1.CustomNodeGroup.DebugProtectionCustomNodeGroup,
    CustomNodeGroup_1.CustomNodeGroup.DomainLockCustomNodeGroup,
    CustomNodeGroup_1.CustomNodeGroup.SelfDefendingCustomNodeGroup,
    CustomNodeGroup_1.CustomNodeGroup.StringArrayCustomNodeGroup
];
__decorate([
    inversify_1.postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CustomNodeGroupStorage.prototype, "initialize", null);
CustomNodeGroupStorage = CustomNodeGroupStorage_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.Factory__ICustomNodeGroup)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TCustomNodeGroupFactory_1.TCustomNodeGroupFactory !== "undefined" && TCustomNodeGroupFactory_1.TCustomNodeGroupFactory) === "function" ? _a : Object, typeof (_b = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _b : Object, typeof (_c = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _c : Object])
], CustomNodeGroupStorage);
exports.CustomNodeGroupStorage = CustomNodeGroupStorage;
